import gql from 'graphql-tag';

export default gql`
    query GetAllocationInventory($jobId: Int) {
      getAllocationInventory(jobId: $jobId) {
            loadId
            proppantColor
            sandTicket
            weightDelivered
            weightRemaining
            fillPerc
            proppantId
            proppantDesc
            boxDesc
            isLoadAllocated
        }
    }
`;